import { Card, Col, Row, Tooltip } from 'antd';
import { HeatmapStatus, mockdata } from './mockdata';
import { useTheme } from 'styled-components';
import { Block } from './styles';

const Heatmap = () => {
  const theme = useTheme();

  const getColor = (status: HeatmapStatus) => {
    switch (status) {
      case HeatmapStatus.DECREASED:
        return theme.antd.colorPrimary;
      case HeatmapStatus.INCREASED:
        return theme.antd.colorWarningText;

      default:
        return theme.antd.colorTextDisabled;
    }
  };

  return (
    <Card title="Heatmap">
      {mockdata.map(({ name, symptoms }) => (
        <Row gutter={[16, 16]} key={name} style={{ marginBottom: 16 }}>
          {symptoms.map((symptom) => (
            <Col key={symptom.name}>
              <Tooltip title={symptom.status}>
                <Block color={getColor(symptom.status)} />
              </Tooltip>
            </Col>
          ))}
        </Row>
      ))}
    </Card>
  );
};

export default Heatmap;
